import styles from './ServiceAgreement.module.scss';
import Link from 'next/link';

export const ServiceAgreement = ({ phrase = 'By signing in, you agree to the' }) => {
  return (
    <div className={styles.container}>
      <p>
        {phrase}&nbsp;
        <Link href="/terms-of-use" target="_blank">Terms of Service</Link>
        &nbsp;and&nbsp;
        <Link href="/privacy-policy" target="_blank">Privacy Policy</Link>
      </p>
    </div>
  );
};
